<template>
  <div class="slide-up-wrap">
    <div class="slide-up" :class="{'slide-up--active': visible, [extraClass]: true }">
      <slot />
      <span class="slide-up-close" @click="hide">
        <aha-icon
          name="close"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        />
      </span>
    </div>
    <div class="slide-up-backdrop" @click="hide" v-if="visible" />
  </div>
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    extraClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style lang="scss">
.slide-up {
  @apply transition-all duration-300 -bottom-full fixed left-0 z-20;
  @apply bg-base-0;

  &--active {
    @apply bottom-0
  }
}

.slide-up-close {
  @apply text-base-0 absolute cursor-pointer right-0 -top-10 p-3;
}

.slide-up-backdrop {
  @apply fixed inset-0 bg-base-100 opacity-50 z-10;
}
</style>
